/**
 * NOTICE:
 *  PLEASE CHANGE ABSOLUTELY YOUR FEATURE NAME HERE
 * ex:
 *  NAME_REDUCER = 'NAME_REDUCER'
 *   => 
 *  NAME_REDUCER = 'booking'
 */
export const NAME_REDUCER = 'store';

/**
 * NOTICE:
 *  PLEASE CHANGE ABSOLUTELY YOUR PREFIX ACTION NAME HERE
 * ex:
 *  PREFIX_ACTIONS = 'PREFIX_ACTIONS';
 *   => 
 *  PREFIX_ACTIONS = 'booking_feature_';
 */
export const PREFIX_ACTIONS = 'store_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};

export enum BusinessType {
  SALON = 'SALON',
  BARBER = 'BARBER',
  SPA = 'SPA',
  RESTAURANT = 'RESTAURANT',
  RETAIL = 'RETAIL',
  HOSPITAL = 'HOSPITAL',
}

export const BUSINESS_TYPE_LABELS: Record<BusinessType, string> = {
  [BusinessType.SALON]: 'Salon',
  [BusinessType.BARBER]: 'Barber',
  [BusinessType.SPA]: 'Spa',
  [BusinessType.RESTAURANT]: 'Restaurant',
  [BusinessType.RETAIL]: 'Retail',
  [BusinessType.HOSPITAL]: 'Hospital',
};

export const BusinessTypeOptions = Object.values(BusinessType).map(type => ({
  label: BUSINESS_TYPE_LABELS[type],
  value: type,
}));